import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckWorkflowNameQueryVariables = Types.Exact<{
  workflowId: Types.InputMaybe<Types.Scalars['Long']['input']>;
  name: Types.Scalars['String']['input'];
  usergroupId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type CheckWorkflowNameQuery = { workflow: { workflowNameExists: { exists: boolean, workflowName: string } } };

export type CheckWorkflowEventNameQueryVariables = Types.Exact<{
  projectId: Types.Scalars['Long']['input'];
  workflowEventName: Types.Scalars['String']['input'];
  workflowEventId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type CheckWorkflowEventNameQuery = { workflow: { workflowEventNameExists: boolean } };

export type ValidatePlaybookPublishPermissionsQueryVariables = Types.Exact<{
  workflowEventId: Types.Scalars['Long']['input'];
}>;


export type ValidatePlaybookPublishPermissionsQuery = { workflow: { publishPermissionCheck: { inaccessibleActivityResourcesData: Array<{ activityIdentifier: string, files: Array<{ id: number, fileName: string | null } | null>, organisms: Array<{ id: number, name: string | null } | null> } | null>, inaccessibleSampleType: { id: number, name: string } | null } } };


export const CheckWorkflowNameDocument = gql`
    query checkWorkflowName($workflowId: Long, $name: String!, $usergroupId: Long) {
  workflow {
    workflowNameExists(
      workflowId: $workflowId
      workflowName: $name
      userGroupId: $usergroupId
    ) {
      exists
      workflowName
    }
  }
}
    `;

/**
 * __useCheckWorkflowNameQuery__
 *
 * To run a query within a React component, call `useCheckWorkflowNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckWorkflowNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckWorkflowNameQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      name: // value for 'name'
 *      usergroupId: // value for 'usergroupId'
 *   },
 * });
 */
export function useCheckWorkflowNameQuery(baseOptions: Apollo.QueryHookOptions<CheckWorkflowNameQuery, CheckWorkflowNameQueryVariables> & ({ variables: CheckWorkflowNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckWorkflowNameQuery, CheckWorkflowNameQueryVariables>(CheckWorkflowNameDocument, options);
      }
export function useCheckWorkflowNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckWorkflowNameQuery, CheckWorkflowNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckWorkflowNameQuery, CheckWorkflowNameQueryVariables>(CheckWorkflowNameDocument, options);
        }
export function useCheckWorkflowNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckWorkflowNameQuery, CheckWorkflowNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckWorkflowNameQuery, CheckWorkflowNameQueryVariables>(CheckWorkflowNameDocument, options);
        }
export type CheckWorkflowNameQueryHookResult = ReturnType<typeof useCheckWorkflowNameQuery>;
export type CheckWorkflowNameLazyQueryHookResult = ReturnType<typeof useCheckWorkflowNameLazyQuery>;
export type CheckWorkflowNameSuspenseQueryHookResult = ReturnType<typeof useCheckWorkflowNameSuspenseQuery>;
export type CheckWorkflowNameQueryResult = Apollo.QueryResult<CheckWorkflowNameQuery, CheckWorkflowNameQueryVariables>;
export const CheckWorkflowEventNameDocument = gql`
    query checkWorkflowEventName($projectId: Long!, $workflowEventName: String!, $workflowEventId: Long) {
  workflow {
    workflowEventNameExists(
      projectId: $projectId
      workflowEventName: $workflowEventName
      workflowEventId: $workflowEventId
    )
  }
}
    `;

/**
 * __useCheckWorkflowEventNameQuery__
 *
 * To run a query within a React component, call `useCheckWorkflowEventNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckWorkflowEventNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckWorkflowEventNameQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      workflowEventName: // value for 'workflowEventName'
 *      workflowEventId: // value for 'workflowEventId'
 *   },
 * });
 */
export function useCheckWorkflowEventNameQuery(baseOptions: Apollo.QueryHookOptions<CheckWorkflowEventNameQuery, CheckWorkflowEventNameQueryVariables> & ({ variables: CheckWorkflowEventNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckWorkflowEventNameQuery, CheckWorkflowEventNameQueryVariables>(CheckWorkflowEventNameDocument, options);
      }
export function useCheckWorkflowEventNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckWorkflowEventNameQuery, CheckWorkflowEventNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckWorkflowEventNameQuery, CheckWorkflowEventNameQueryVariables>(CheckWorkflowEventNameDocument, options);
        }
export function useCheckWorkflowEventNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckWorkflowEventNameQuery, CheckWorkflowEventNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckWorkflowEventNameQuery, CheckWorkflowEventNameQueryVariables>(CheckWorkflowEventNameDocument, options);
        }
export type CheckWorkflowEventNameQueryHookResult = ReturnType<typeof useCheckWorkflowEventNameQuery>;
export type CheckWorkflowEventNameLazyQueryHookResult = ReturnType<typeof useCheckWorkflowEventNameLazyQuery>;
export type CheckWorkflowEventNameSuspenseQueryHookResult = ReturnType<typeof useCheckWorkflowEventNameSuspenseQuery>;
export type CheckWorkflowEventNameQueryResult = Apollo.QueryResult<CheckWorkflowEventNameQuery, CheckWorkflowEventNameQueryVariables>;
export const ValidatePlaybookPublishPermissionsDocument = gql`
    query validatePlaybookPublishPermissions($workflowEventId: Long!) {
  workflow {
    publishPermissionCheck(workflowEventId: $workflowEventId) {
      inaccessibleActivityResourcesData {
        activityIdentifier
        files {
          id
          fileName
        }
        organisms {
          id
          name
        }
      }
      inaccessibleSampleType {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useValidatePlaybookPublishPermissionsQuery__
 *
 * To run a query within a React component, call `useValidatePlaybookPublishPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePlaybookPublishPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePlaybookPublishPermissionsQuery({
 *   variables: {
 *      workflowEventId: // value for 'workflowEventId'
 *   },
 * });
 */
export function useValidatePlaybookPublishPermissionsQuery(baseOptions: Apollo.QueryHookOptions<ValidatePlaybookPublishPermissionsQuery, ValidatePlaybookPublishPermissionsQueryVariables> & ({ variables: ValidatePlaybookPublishPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePlaybookPublishPermissionsQuery, ValidatePlaybookPublishPermissionsQueryVariables>(ValidatePlaybookPublishPermissionsDocument, options);
      }
export function useValidatePlaybookPublishPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePlaybookPublishPermissionsQuery, ValidatePlaybookPublishPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePlaybookPublishPermissionsQuery, ValidatePlaybookPublishPermissionsQueryVariables>(ValidatePlaybookPublishPermissionsDocument, options);
        }
export function useValidatePlaybookPublishPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidatePlaybookPublishPermissionsQuery, ValidatePlaybookPublishPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidatePlaybookPublishPermissionsQuery, ValidatePlaybookPublishPermissionsQueryVariables>(ValidatePlaybookPublishPermissionsDocument, options);
        }
export type ValidatePlaybookPublishPermissionsQueryHookResult = ReturnType<typeof useValidatePlaybookPublishPermissionsQuery>;
export type ValidatePlaybookPublishPermissionsLazyQueryHookResult = ReturnType<typeof useValidatePlaybookPublishPermissionsLazyQuery>;
export type ValidatePlaybookPublishPermissionsSuspenseQueryHookResult = ReturnType<typeof useValidatePlaybookPublishPermissionsSuspenseQuery>;
export type ValidatePlaybookPublishPermissionsQueryResult = Apollo.QueryResult<ValidatePlaybookPublishPermissionsQuery, ValidatePlaybookPublishPermissionsQueryVariables>;